import ProtectedRoute from "../../auth/ProtectedRoute";
import { Route, Routes, useLocation } from "react-router-dom";
import AdminDashboard from "../../admin/AdminDashboard";
import Transactions from "../../pages/admin/Transactions";
import PaymentManagerAdmin from "../../pages/admin/PaymentManagerAdmin";
import AppLogs from "../../pages/admin/AppLogs";
import Guests from "../../pages/admin/Guests";
import SupportRequests from "../../pages/admin/SupportRequests";
import SetupSessions from "../../pages/admin/SetupSessions";
import SetupAdmin from "../../pages/SetupAdmin";
import ActionAdmin from "../../pages/admin/ActionAdmin";
import Orgs from "../../pages/admin/Orgs";
import Org from "../../pages/admin/Org";
import Users from "../../pages/admin/Users";
import Logs from "../../pages/admin/Logs";
import User from "../../pages/admin/User";
import Payouts from "../../pages/admin/Payouts";
import Hexamails from "../../pages/admin/hexamails/Hexamails";

const AdminRoutes = ({
  navigateWorkspace,
  handleLoginAs,
  userData,
  orgData,
}) => {
  const location = useLocation();

  return (
    <Routes>
      <Route
        path="dashboard"
        element={<AdminDashboard navigateWorkspace={navigateWorkspace} />}
      />
      <Route
        path="hexamails"
        element={<Hexamails navigateWorkspace={navigateWorkspace} />}
      />
      <Route
        path="/orgs"
        element={<Orgs navigateWorkspace={navigateWorkspace} />}
      />
      <Route
        path="/org/:id"
        element={
          <Org
            userData={userData}
            orgData={orgData}
            navigateWorkspace={navigateWorkspace}
            handleLoginAs={handleLoginAs}
          />
        }
      />
      <Route
        path="/users"
        element={<Users navigateWorkspace={navigateWorkspace} />}
      />
      <Route
        path="/guests"
        element={<Guests navigateWorkspace={navigateWorkspace} />}
      />
      <Route
        path="/user/:id"
        element={
          <User
            navigateWorkspace={navigateWorkspace}
            handleLoginAs={handleLoginAs}
          />
        }
      />
      <Route
        path="/logs"
        element={
          <Logs
            navigateWorkspace={navigateWorkspace}
            handleLoginAs={handleLoginAs}
          />
        }
      />
      <Route
        path="/applogs"
        element={<AppLogs navigateWorkspace={navigateWorkspace} />}
      />
      <Route
        path="/support-requests"
        element={<SupportRequests navigateWorkspace={navigateWorkspace} />}
      />
      <Route
        path="/action-admin"
        element={
          <ActionAdmin navigateWorkspace={navigateWorkspace}></ActionAdmin>
        }
      />
      <Route
        path="/setup-sessions"
        element={<SetupSessions navigateWorkspace={navigateWorkspace} />}
      />
      <Route
        path="/setup-session/:id"
        element={<SetupAdmin navigateWorkspace={navigateWorkspace} />}
      />
      <Route
        path="/transactions"
        element={<Transactions navigateWorkspace={navigateWorkspace} />}
      />{" "}
      <Route
        path="/payouts"
        element={<Payouts navigateWorkspace={navigateWorkspace} />}
      />{" "}
      <Route
        path="/admin-payments"
        element={<PaymentManagerAdmin navigateWorkspace={navigateWorkspace} />}
      />
    </Routes>
  );
};

export default AdminRoutes;
